import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessorReportsService, ProcessorReport } from 'src/app/services/processor-reports.service';
import { AuthService } from 'src/app/services/auth.service';
import * as moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { Client } from 'src/app/clients-module/models/clientLocation';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-client-tat-breakdown-dialog',
  templateUrl: './client-tat-breakdown-dialog.component.html',
  styleUrls: ['./client-tat-breakdown-dialog.component.less']
})
export class ClientTatBreakdownDialogComponent implements OnInit,OnDestroy {
  report : ProcessorReport;
  public fromDate: any;
  availableClients: Client[];
  clientSub$: Subscription;
  selectedClient: Client;
  loading: boolean;
  partyOn : Subject<any> = new Subject<any >();
  constructor(public modalRef: NgbModal, public procRpts : ProcessorReportsService, public auth: AuthService, public client: ClientService) { }
  ngOnDestroy(): void {
    this.modalRef.dismissAll();
    if(this.clientSub$) this.clientSub$.unsubscribe();
  }

  cancel(){
    this.modalRef.dismissAll();
  }

  download(){
    var vals = {};
    vals['startDate'] = this.fromDate;
    vals['clientId'] = this.selectedClient.id;
    this.partyOn.next(vals);
  }

  ngOnInit(): void {
    this.loading = true;
    this.clientSub$ = this.client.FetchLightClientList().pipe(tap(_ => 
        { this.availableClients = _; this.loading = false; })).subscribe();
  }


}
